<script>
  // import InputStore from './stores/inputs.js';
  export let patientData;

</script>

<section class="demo_dials">
  <div class="control">
    <h3>Street Address</h3>
    <input class="input" type="text" placeholder="Address">
  </div>
  <div class="control">
    <h3>Zip Code</h3>
    <input class="input" type="text" placeholder="Zip Code" bind:value={patientData.zipcode}>
  </div>

  <div class="control">
    <h3>Gender</h3>
    <label class="radio">
      <input type="radio" name="gender">
      Male
    </label>
    <label class="radio">
      <input type="radio" name="gender">
      Female
    </label>
    <label class="radio">
      <input type="radio" name="gender" checked>
      Unknown
    </label>
  </div>

  <div class="control ethnicity">
    <h3>Race / Ethnicity</h3>
    <label class="radio">
      <input type="radio" name="ethnicity">
      American Indian/Alaska Native
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
      Asian
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
     Native Hawaiian or Other Pacific Islander
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
      Black or African-American
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
      White
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
      Hispanic or Latina(o)
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity">
     Not Hispanic or Latina(o)
    </label>
    <label class="radio">
      <input type="radio" name="ethnicity" checked>
      Unknown
    </label>
  </div>

  <div class="control">
    <h3>Age</h3>
    <input class="input age" type="text" placeholder="Age">
  </div>
</section>

<style>
  .control{
    margin:10px 0 30px 0;
  }
  input.age{
    width:80px;
  }
  .ethnicity label{
    display:block;
    margin-left: 7px;
  }
</style>
